import React, { useEffect } from "react";
import { Form, Input, InputNumber, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { update } from "../../../store/features/orders/createSlice";

const ShippingInfo = ({ updateTab }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const orderStoreDetails = useSelector((state) => state.order.orders);
  const { TextArea } = Input;

  useEffect(() => {
    //updateTab(orderStoreDetails.type === "courier" ? 2 : 1);
    form.setFieldsValue(orderStoreDetails.address);
  }, []);

  const onFinish = (values) => {
    dispatch(update({ address: values }));
    updateTab(3);
  };

  return (
    <Form layout={"vertical"} form={form} onFinish={onFinish}>
      <Form.Item
        label="Full Name"
        name="name"
        rules={[
          {
            required: orderStoreDetails.type === "courier" ? true : false,
            message: "Name is required",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Address"
        name="address"
        rules={[
          {
            required: orderStoreDetails.type === "courier" ? true : false,
            message: "Address is required",
          },
        ]}
      >
        <TextArea
          // value={value}
          // onChange={(e) => setValue(e.target.value)}
          autoSize={{
            minRows: 3,
            maxRows: 5,
          }}
        />
      </Form.Item>
      <Form.Item
        label="City"
        name="city"
        rules={[
          {
            required: orderStoreDetails.type === "courier" ? true : false,
            message: "City is required",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Zip Code"
        name="zip"
        rules={[
          {
            required: orderStoreDetails.type === "courier" ? true : false,
            message: "Zip Code is required",
          },
        ]}
      >
        <InputNumber className="w-100" />
      </Form.Item>
      <Form.Item
        label="Phone No"
        name="phone"
        rules={[
          {
            required: orderStoreDetails.type === "courier" ? true : false,
            message: "Phone No is required",
          },
        ]}
      >
        <InputNumber className="w-100" />
      </Form.Item>
      <Form.Item label="Email" name="email">
        <Input />
      </Form.Item>
      <Form.Item label="GST No" name="gstNo">
        <Input />
      </Form.Item>
      <Form.Item
        label="WhatsApp No"
        name="whatsApp"
        rules={[
          {
            required: orderStoreDetails.type === "courier" ? true : false,
            message: "WhatsApp No is required",
          },
        ]}
      >
        <InputNumber className="w-100" />
      </Form.Item>
      <Form.Item style={{ textAlign: "left" }}>
        <Button type="primary" htmlType="submit">
          Next
        </Button>
        {/* <Button
          style={{
            margin: "0 8px",
          }}
          onClick={(e) => {
            updateTab(1);
          }}
        >
          Previous
        </Button> */}
      </Form.Item>
    </Form>
  );
};

export default ShippingInfo;
